import React from 'react'
import WelcomeModal from '../WelcomeModal';
import DeclinedModal from '../DeclinedModal';
import ProviderDashboardNavigationBar from "./DashboardNavigationBar";
import WelcomeBanner from "./WelcomeBanner";
import ContentWrapper from "../ContentWrapper";
import AuthCallback from "../AuthCallback";

const DashboardHeader = () => {
    return (
        <div>
          <WelcomeModal />
          <DeclinedModal />
          <ProviderDashboardNavigationBar />
          <WelcomeBanner />
        </div>
    )
}

export default DashboardHeader;
